import wpaWifi from "./wpaWIfi.js";
import { command, isDefined } from "../../../../shared/utils.js";
import wifiPwdRecord from "../../../../settings/wifiPwdRecord.js";
import fileSys from "../../../../fileoprators/fileSystem.js";
import { getwifiCfg } from "../../../../settings/index.js";

const enconv = window.require("encoding");
const { exec, spawn } = window.require("child_process");
const util = window.require("util");
// const execPromis = util.promisify(exec)
// const wlnname = 'wlp2s0'
//  wifi
function getWificfg() {
  return wpaWifi.readCfg();
}
async function runCmdSpawn(cmd, params) {
  return new Promise((resolve, reject) => {
    const sp = spawn(cmd, params);
    sp.on("error", () => {
      resolve(undefined);
    });
    sp.stdout.on("data", (data) => {
      resolve(data.toString());
    });
  });
}
async function scanWifi() {
  if (typeof wpaWifi.scan !== "function") {
    return;
  }
  let stdout = await wpaWifi.scan();
  let pattern = /^[\\\\x00]*$/;
  for (let key in stdout) {
    let str = stdout[key].ssid;
    let ssidTostr = decode(str);
    if (isDefined(ssidTostr)) {
      stdout[key].ssid = ssidTostr.replace("\n", "");
    } else {
      delete stdout[key];
    }
    // try {
    //   let ssidTostr = execSync(command(str))
    //   stdout[key].ssid = ssidTostr.toString().replace('\n', '')
    // } catch (e) {
    //   console.log('scanWifissidTostr', stdout[key])
    //   console.error(e)
    //   delete stdout[key]
    // }
  }
  try {
    let arr = Object.values(stdout);
    for (let i = 0; i < arr.length; i++) {
      if (!arr[i].ssid) {
        delete stdout[arr[i].bssid];
      } else {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].ssid === arr[j].ssid && arr[i].freq[0] === arr[j].freq[0]) {
            delete stdout[arr[i].bssid];
          }
        }
      }
    }
  } catch (e) {}
  stdout = Object.values(stdout).sort((a, b) => {
    return b.rssi - a.rssi;
  });
  return stdout;
}
function isStrUTF8(strbuf) {
  let nBytes = 0; // UFT8可用1-6个字节编码,ASCII用一个字节
  let chr = strbuf[0];
  let bAllAscii = true;
  for (let i = 0; i < strbuf.length; i++) {
    chr = strbuf[i];
    // 判断是否ASCII编码,如果不是,说明有可能是UTF8,ASCII用7位编码,最高位标记为0,0xxxxxxx
    if (nBytes === 0 && (chr & 0x80) !== 0) {
      bAllAscii = false;
    }
    if (nBytes === 0) {
      // 如果不是ASCII码,应该是多字节符,计算字节数
      if (chr >= 0x80) {
        if (chr >= 0xfc && chr <= 0xfd) {
          nBytes = 6;
        } else if (chr >= 0xf8) {
          nBytes = 5;
        } else if (chr >= 0xf0) {
          nBytes = 4;
        } else if (chr >= 0xe0) {
          nBytes = 3;
        } else if (chr >= 0xc0) {
          nBytes = 2;
        } else {
          return false;
        }
        nBytes--;
      }
    } else {
      // 多字节符的非首字节,应为 10xxxxxx
      if ((chr & 0xc0) !== 0x80) {
        return false;
      }
      // 减到为零为止
      nBytes--;
    }
  }
  // 违返UTF8编码规则
  if (nBytes !== 0) {
    return false;
  }
  if (bAllAscii) {
    // 如果全部都是ASCII, 也是UTF8
    return true;
  }
  return true;
}

function decode(str) {
  let res = -1;
  let arr = [];
  do {
    res = str.search(/\\x(\w{2})/);
    if (res > 0) {
      for (let i = 0; i < res; i++) {
        let v = str[i].charCodeAt();
        arr.push(v);
      }
      str = str.substring(res);
    } else if (res === 0) {
      let v = parseInt(str.substring(2, 4), 16);
      arr.push(v);
      str = str.substring(4);
    }
  } while (res >= 0);
  for (let i = 0; i < str.length; i++) {
    let v = str[i].charCodeAt();
    arr.push(v);
  }

  let buf = Buffer.from(arr);
  if (!isStrUTF8(buf)) {
    return enconv.convert(buf, "UTF8", "GBK").toString();
  }
  return buf.toString();
}

async function stateWifi() {
  if (typeof wpaWifi.status !== "function") {
    return;
  }
  let wpa = await wpaWifi.status();
  wpa["ConnStatus"] = wpaWifi.getConnStatus();
  wpa = JSON.parse(JSON.stringify(wpa));
  if (wpa.ssid) {
    // let pattern = /^[\\\\x00]*$/
    let str = wpa["ssid"];
    // let ssidTostr = filSys.spawnSyncCmd('echo', ['-e', `${ wpa.ssid.toString().replaceAll('\\\\', '\\\\').replaceAll(pattern, '') } `])
    let ssidTostr = decode(str);
    if (isDefined(ssidTostr)) {
      wpa.ssid = ssidTostr.replace("\n", "");
    }
    // console.log('wifi get:', str, wpa)
    // let ssidTostr = execSync(command(str))
    // wpa.ssid = ssidTostr.toString().replace('\n', '') // (await execPromis('"' + str + '"')).stdout.replace('\n', '')
  }
  return wpa;
}
function getWifiConfig() {
  let config = {};
  return new Promise((resolve, reject) => {
    let cfg = fileSys.getWifiConfig();
    window.wifiCfg = getwifiCfg();

    if (isDefined(cfg)) {
      cfg.mask = cfg.netmask || "";
      config = { ...config, ...cfg };
      if (window.wifiCfg && window.wifiCfg.mode) {
        config.method = window.wifiCfg.mode;
      }
      exec(
        command(`route -n | grep ${cfg.netCardName} | awk -F ' ' '{print $2 " " $4}'`),
        (error, stdout) => {
          let sOut = stdout.toString().trim();
          if (isDefined(error) || sOut === "") {
            reject(error.message);
          } else {
            let arrLines = sOut.split("\n");
            arrLines.forEach((line) => {
              let arr = line.split(" ");
              if (isDefined(arr) && arr.length > 0 && arr[1].indexOf("UG") >= 0) {
                config["gateway"] = arr[0];
              }
            });
            config.gateway = config.gateway || "";
            exec("cat /etc/resolv.conf | grep nameserver", (error, stdout) => {
              if (isDefined(error)) {
                reject(error.message);
              } else {
                let sOut1 = stdout.toString().trim();
                if (sOut1 === "") {
                  reject(new Error("DNS is wrong").message);
                } else {
                  config["dns"] = sOut1.split(" ")[1] || "";
                  resolve(config);
                }
              }
            });
          }
        }
      );
    } else {
      reject(new Error("wlan not connect"));
    }
    // exec(command('ifconfig'), (error, stdout) => {
    //   if (error) {
    //     reject(error.message)
    //   } else {
    //     stdout = stdout.split('\n')
    //     for (let i = 0; i <= stdout.length; i++) {
    //       if (stdout[i].includes(wlnname)) {
    //         let str = stdout[i + 1].trim()
    //         str = str.split(' ')
    //         config['mask'] = str[4]
    //         config['address'] = str[1]
    //         exec(command('route -n'), (error1, stdout1) => {
    //           if (error1) {
    //             console.log(error1)
    //             resolve(config)
    //           } else {
    //             stdout1 = stdout1.split('\n')
    //             for (let i = 0; i <= stdout1.length; i++) {
    //               if (stdout1[i].includes(wlnname)) {
    //                 config['gateway'] = stdout1[i].split(' ')[9]
    //                 exec('cat /etc/resolv.conf', (errorDns, stdoutDns) => {
    //                   if (errorDns) {
    //                     console.log('errorDNs', errorDns)
    //                     resolve(config)
    //                   } else {
    //                     stdoutDns = stdoutDns.split('\n')
    //                     for (let index = 0; index < stdoutDns.length; index++) {
    //                       const element = stdoutDns[index]
    //                       if (element.includes('nameserver')) {
    //                         config['dns'] = element
    //                           .split('nameserver')[1]
    //                           .trim()
    //                         console.log(config)
    //                       }
    //                     }
    //                     resolve(config)
    //                   }
    //                 })
    //                 break
    //               }
    //             }
    //           }
    //         })
    //         break
    //       }
    //     }
    //   }
    // })
  });
}
async function getNetworks() {
  if (typeof wpaWifi.getNetworks !== "function") {
    return;
  }
  let networks = await wpaWifi.getNetworks();
  return networks;
}
function disconnectWifi() {
  return new Promise((resolve, reject) => {
    wpaWifi
      .disconnect(true)
      .then(() => {
        resolve(true);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
async function connectWifi(cfg, hasHide = false) {
  return new Promise((resolve, reject) => {
    wpaWifi
      .connect(cfg, hasHide)
      .then(() => {
        resolve(true);
      })
      .catch((err) => {
        reject(err.message);
      });
  });
}
function getConnStatus() {
  if (typeof wpaWifi.getConnStatus !== "function") {
    return;
  }
  return wpaWifi.getConnStatus();
}
function getScanStatus() {
  if (typeof wpaWifi.getConnStatus !== "function") {
    return;
  }
  return wpaWifi.getConnStatus();
}
function getWifiPWdRe(item) {
  let wifiitem = window.wifiPwdRecord;
  return wifiitem[item.ssid];
}
function setWifiPwdRe(item, state) {
  // ssid:{ssid: '', psk: '', updatetime: ''}
  if (!item.hasOwnProperty("psk")) return;
  let wifiitem = window.wifiPwdRecord;
  if (state) {
    let cfg = {
      ssid: item.ssid,
      psk: item.psk,
      hasHide: item.hasHide,
      updatetime: new Date().format("yyyy-MM-dd hh:mm:ss").toString()
    };
    if (Object.values(wifiitem).length > 10) {
      let cfgList = Object.values(wifiitem);
      let mincfg = cfgList[0];
      for (let index = 0; index < cfgList.length; index++) {
        const element = cfgList[index];
        if (element.updatetime < mincfg.updatetime) {
          mincfg = element;
        }
      }
      delete wifiitem[mincfg.ssid];
    }
    wifiitem[cfg.ssid] = cfg;
  } else {
    if (Object.keys(wifiitem).includes(item.ssid)) {
      delete wifiitem[item.ssid];
    }
  }
  wifiPwdRecord.saveWifiPWdSettings(wifiitem);
}
function disable() {
  return new Promise((resolve, reject) => {
    wpaWifi
      .disable()
      .then(() => {
        resolve(true);
      })
      .catch((err) => {
        reject(err.message);
      });
  });
}

function enable() {
  return new Promise((resolve, reject) => {
    wpaWifi
      .enable()
      .then(() => {
        resolve(true);
      })
      .catch((err) => {
        reject(err.message);
      });
  });
}
export default {
  setWifiPwdRe,
  getWifiPWdRe,
  getConnStatus,
  getNetworks,
  getScanStatus,
  connectWifi,
  disconnectWifi,
  getWificfg,
  scanWifi,
  stateWifi,
  getWifiConfig,
  disable,
  enable
};



// WEBPACK FOOTER //
// ./src/mainInterface/js/wifi/wpa_wifi/index.js